import styled from 'styled-components'

import { lightSalmon } from '../../styles/themeColors'

export const Profile = styled.span`
  background-color: ${lightSalmon};
  border-radius: 50%;
  display: inline-block;
  justify-content: center;
  padding: 8px;
  vertical-align: top;
`
